
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokarelacabs() {



    const cardData =
    {
        keyword: 'Pune to Kerala Cabs ',
        heading: 'Platinum24 Cabs: Pune to Kerala Cabs',
        headingDescription: ' Platinum24 Cabs provides reliable Pune to Kerala cab services, perfect for family vacations, pilgrimages, and business travel across God’s Own Country. Whether you’re visiting Kochi, Munnar, Alleppey backwaters, or Sabarimala Temple, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable ride. With professional chauffeurs, punctual pickups, and transparent pricing, we make your long-distance journey hassle-free and enjoyable. From one-way drops to customized holiday packages, Platinum24 Cabs guarantees dependable service and a memorable Pune to Kerala travel experience.',

        top: 'Top Places to Visit in Kerala with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Alleppey Backwaters",
    "description": "Alleppey, known as the Venice of the East, is famous for its tranquil backwaters and houseboat cruises. Travelers glide through palm-fringed canals, paddy fields, and village life on kettuvallam houseboats. Overnight stays with local cuisine make it unforgettable. The annual Nehru Trophy Boat Race adds excitement. Alleppey is Kerala’s serene backwater paradise."
  },
  {
    "title": "Munnar",
    "description": "Munnar is a hill station blanketed with tea plantations, rolling hills, and misty valleys. Its attractions include Eravikulam National Park, Anamudi Peak, and tea museums. Monsoon and winters make the scenery magical. Honeymooners and nature lovers find it ideal. Adventure activities like trekking and paragliding add thrill. Munnar is Kerala’s green mountain retreat."
  },
  {
    "title": "Kochi",
    "description": "Kochi, a vibrant port city, blends Portuguese, Dutch, and British influences with Kerala’s culture. Chinese fishing nets, Mattancherry Palace, and Jew Town are must-sees. The city also boasts art cafes, Kathakali shows, and spice markets. Marine Drive and Fort Kochi attract both tourists and photographers. Kochi is Kerala’s cultural and coastal melting pot."
  },
  {
    "title": "Kumarakom",
    "description": "Kumarakom is a picturesque backwater village on Vembanad Lake. It is famous for bird watching at Kumarakom Bird Sanctuary. Houseboats and canoe rides offer peaceful escapes. Ayurvedic resorts and homestays enrich the experience. Sunset views over the lake are breathtaking. Kumarakom is Kerala’s nature and wellness haven."
  },
  {
    "title": "Wayanad",
    "description": "Wayanad is a lush district known for waterfalls, caves, wildlife, and spice plantations. Edakkal Caves, Soochipara Falls, and Wayanad Wildlife Sanctuary are top attractions. Trekking trails like Chembra Peak offer adventure. Monsoon enhances its green landscapes. Eco-tourism initiatives preserve its natural charm. Wayanad is Kerala’s wild mountain gem."
  },
  {
    "title": "Thekkady",
    "description": "Thekkady, home to Periyar Wildlife Sanctuary, is Kerala’s top wildlife destination. Visitors enjoy boat rides on Periyar Lake, spotting elephants, bison, and deer. Spice plantations nearby offer guided tours. Bamboo rafting and trekking add adventure. The air is filled with the aroma of cardamom and pepper. Thekkady is Kerala’s wild and aromatic retreat."
  },
  {
    "title": "Varkala Beach",
    "description": "Varkala Beach is unique for its dramatic cliffs overlooking the Arabian Sea. It is popular for sunbathing, surfing, and Ayurvedic treatments. The Papanasam Beach is considered holy, where devotees take ritual dips. Beachside shacks and yoga centers attract international travelers. Sunsets from the cliffside are mesmerizing. Varkala is Kerala’s scenic coastal escape."
  },
  {
    "title": "Trivandrum (Thiruvananthapuram)",
    "description": "Kerala’s capital, Trivandrum, is famous for the Padmanabhaswamy Temple, one of the richest temples in the world. The city also boasts Napier Museum, Zoo, and Kovalam Beach nearby. Cultural festivals and classical music add vibrancy. Its mix of heritage and modernity attracts tourists year-round. Trivandrum is Kerala’s cultural and spiritual capital."
  },
  {
    "title": "Athirappilly Waterfalls",
    "description": "Athirappilly, known as the ‘Niagara of India,’ features Kerala’s largest waterfall plunging 80 feet. Surrounded by dense forests, it is a favorite for nature lovers and filmmakers. Trekking trails offer closer views of the cascade. The falls are spectacular during monsoon. It is home to hornbills and rich biodiversity. Athirappilly is Kerala’s majestic natural wonder."
  },
  {
    "title": "Bekal Fort",
    "description": "Bekal Fort, located on Kerala’s northern coast, is the state’s largest fort overlooking the Arabian Sea. Built in the 17th century, it offers panoramic views of beaches and waves crashing against its bastions. Its unique keyhole shape is famous. The fort is often featured in movies and photography. Bekal Fort is Kerala’s historic seaside fortress."
  }
],


                   "services": [
    {
      "name": "Pune to Kerala Cab",
      "description": "Embark on a memorable journey from Pune to Kerala with our reliable Pune to Kerala Cab service. Whether you’re traveling for vacation, business, or family visits, our well-maintained fleet of vehicles ensures a smooth and comfortable ride across this long-distance route. Our professional drivers are experienced with highway driving and are knowledgeable about the best routes, ensuring timely arrivals and a safe journey. Enjoy modern amenities like air conditioning, spacious interiors, and ample luggage space. We also offer flexible pickup and drop locations to suit your convenience, along with 24/7 customer support to address any queries or changes."
    },
    {
      "name": "Book Pune to Kerala Taxi",
      "description": "Booking your Pune to Kerala Taxi has never been easier with our seamless online platform. Select your preferred vehicle type, choose your travel dates, and get instant booking confirmation with transparent fare estimates. Our user-friendly interface allows you to customize your trip with options like stopovers, additional luggage, or special assistance. We accept multiple secure payment methods and provide round-the-clock customer service to ensure your booking process is smooth and hassle-free."
    },
    {
      "name": "Pune to Kerala Cab Booking",
      "description": "Reserve your Pune to Kerala Cab in advance with our convenient booking system, designed to cater to both last-minute travelers and planners. Our cab booking service guarantees availability of vehicles suited for solo travelers, families, or groups, with options ranging from compact sedans to spacious SUVs. Transparent pricing and detailed trip information help you plan your budget accurately. Our dedicated support team is available to assist with any special requirements or itinerary adjustments, ensuring a stress-free experience from start to finish."
    },
    {
      "name": "Pune to Kerala Car Hire",
      "description": "Take control of your journey with our Pune to Kerala Car Hire service, offering both self-drive and chauffeur-driven options. Whether you prefer the freedom of driving yourself or the comfort of a professional driver, we provide well-maintained vehicles equipped with modern amenities and safety features. Flexible rental durations and competitive pricing make our car hire service ideal for tourists, business travelers, and families. Enjoy clean, sanitized cars and reliable roadside assistance throughout your trip."
    },
    {
      "name": "Pune to Kerala One Way Taxi",
      "description": "Our Pune to Kerala One Way Taxi service offers you an economical and flexible travel option without the need to arrange for a return journey. Ideal for relocations, business trips, or visits, this service ensures you get a dedicated vehicle and driver for a one-way trip at competitive rates. All vehicles are regularly inspected and sanitized to provide a safe and comfortable ride. Experience hassle-free travel with prompt pickups, courteous drivers, and transparent pricing tailored to your route."
    },
    {
      "name": "Kerala to Pune Cab Service",
      "description": "Plan your return journey with our Kerala to Pune Cab Service, featuring reliable transportation options that prioritize your comfort and safety. Our fleet is equipped to handle long-distance travel with spacious seating and ample luggage capacity. Professional drivers familiar with the route ensure timely arrivals and smooth navigation. Book online or via phone with ease, and enjoy customer support that’s available around the clock to help with any travel needs or changes."
    },
    {
      "name": "Pune to Kerala Road Trip Taxi",
      "description": "Experience the scenic route in style with our Pune to Kerala Road Trip Taxi service, perfect for travelers who want to enjoy the journey as much as the destination. Our vehicles are comfortable and equipped with entertainment options to make long drives enjoyable. Professional drivers knowledgeable about tourist attractions and scenic spots can also assist in planning stops and detours. Whether it’s a family vacation or a solo adventure, our road trip taxi service ensures a memorable travel experience."
    },
    {
      "name": "Pune to Kerala Outstation Cab",
      "description": "For those planning longer trips, our Pune to Kerala Outstation Cab service offers dependable and comfortable travel options. Vehicles are chosen for their reliability and comfort, equipped to handle extended travel times. Our drivers prioritize your safety, maintain a steady pace, and manage rest stops effectively. Enjoy flexible pickup and drop locations, clear fare estimates, and 24/7 support to make your outstation travel seamless and stress-free."
    },
    {
      "name": "Pune to Kerala Taxi Fare",
      "description": "Get accurate and transparent Pune to Kerala Taxi Fare details upfront, so you can plan your travel budget without surprises. Our fare structure accounts for distance, vehicle type, tolls, and any additional services, ensuring clarity and fairness. Special discounts and offers are frequently available for early bookings, return journeys, and group travel. Contact our support team anytime for personalized fare quotes or to clarify any questions about charges."
    },
    {
      "name": "Affordable Cabs from Pune to Kerala",
      "description": "Travel economically with our Affordable Cabs from Pune to Kerala, offering great value without compromising on comfort or safety. Our budget-friendly options are ideal for students, solo travelers, and families looking to save on transportation costs. Despite the affordable pricing, we maintain high standards for vehicle maintenance, hygiene, and driver professionalism. Enjoy flexible payment options, regular promotions, and the same reliable service as our premium offerings."
    }
  ],
  "tableData": [
    ["Pune to Kerala Cab", "Book Pune to Kerala Taxi"],
    ["Pune to Kerala Cab Booking", "Pune to Kerala Car Hire"],
    ["Pune to Kerala One Way Taxi", "Kerala to Pune Cab Service"],
    ["Pune to Kerala Road Trip Taxi", "Pune to Kerala Outstation Cab"],
    ["Pune to Kerala Taxi Fare", "Affordable Cabs from Pune to Kerala"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Kerala Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs provides comfortable and dependable cab services for your journey from Pune to Kerala, ensuring a smooth and enjoyable travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Travel Needs",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers, all well-maintained and perfect for long-distance travel from Pune to Kerala."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Your Safety",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic travel environment."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Kerala Routes",
    "WhyChoosedescription": "Our skilled drivers know the best routes between Pune and Kerala to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy affordable fares with all costs, including fuel, tolls, and driver allowances, clearly included in the price."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist you with your Pune to Kerala cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long-Term Travel",
    "WhyChoosedescription": "Choose from hourly, daily, or customized rental plans tailored to your Pune to Kerala travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Kerala cab quickly and securely through our website or app with immediate confirmation."
  }
]

























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Kerala cab services?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Kerala with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Kerala?',
        answer: 'You can book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Kerala travel?',
        answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars to suit your travel preferences and group size.',
    },
    {
        question: 'Is one-way cab service available from Pune to Kerala?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Kerala travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Kerala long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Kerala routes.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Kerala?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points to fit your travel plans.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Kerala cabs?',
        answer: 'All vehicles are regularly sanitized, and drivers follow strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Kerala cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Kerala cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Kerala cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for smooth payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Kerala cab services?',
        answer: 'Yes, we offer flexible packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Thomas Joseph',
        feedback: 'The Pune to Kerala cab service was excellent—comfortable ride and professional driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Mathew',
        feedback: 'Highly recommended Platinum24 Cabs for Pune to Kerala travel. Great service and clean cars.',
        rating: 5,
    },
];















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToKeralaCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Kerala Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-kerala-cab.jpg",
  "description": "Book Pune to Kerala cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable, safe, and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-kerala-cab-service"
  }
};



    return (
        <div>
<Helmet>
  <title>Pune to Kerala Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Kerala cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable, safe, and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Kerala Cab, Book Pune to Kerala Taxi, Pune to Kerala Cab Booking, Pune to Kerala Car Hire, Pune to Kerala One Way Taxi, Kerala to Pune Cab Service, Pune to Kerala Road Trip Taxi, Pune to Kerala Outstation Cab, Pune to Kerala Taxi Fare, Affordable Cabs from Pune to Kerala"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToKeralaCabSchema)}
  </script>
</Helmet>





            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/109.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokarelacabs;